
import { defineComponent, ref } from 'vue'
import UserLoginWrapper from '@/components/auth-wrappers/UserLoginWrapper.vue'
import ProximityInfo from '@/components/layout/ProximityInfo.vue'
import DoubleScroll from '@/components/layout/DoubleScroll.vue'
import { RequestHeaderProximityForm } from '@/types/forms'

/**
 * 近接工事申請件名新規登録
 */
export default defineComponent({
  name: 'ProximityAdd',
  components: {
    UserLoginWrapper,
    ProximityInfo,
    DoubleScroll,
  },
  setup() {
    const detail = ref<RequestHeaderProximityForm | null>(null)
    return {
      detail,
    }
  },
})
